import { render } from "./DataTradingInfo.vue?vue&type=template&id=02d36491&scoped=true"
import script from "./DataTradingInfo.vue?vue&type=script&lang=js"
export * from "./DataTradingInfo.vue?vue&type=script&lang=js"

import "./DataTradingInfo.vue?vue&type=style&index=0&id=02d36491&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d36491"]])

export default __exports__